// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientFinderResultSearchBase } from './patientFinderResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientFinderResultSearchResponse {
    'results'?: Array<PatientFinderResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientFinderResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<PatientFinderResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return PatientFinderResultSearchResponse.attributeTypeMap;
    }
}
